import styled from 'styled-components'
import { typography } from '../styles'

const H3 = styled.h3`
  ${typography.h2.uppercase.bold.pink.center}
  margin-bottom: 2rem;
`

export default H3



/** WEBPACK FOOTER **
 ** ./src/components/H3.js
 **/